import { useState as e, useRef as t } from "react";
const c = () => {
  const [o, s] = e(!1), [n, l] = e(!1), r = t(null), p = t(null);
  return {
    playerRef: r,
    parentRef: p,
    initialed: o,
    setInitialed: s,
    forceStopped: n,
    setForceStopped: l
  };
};
export {
  c as useVideo
};
